'use client';

import type { ParsedSeoScripts } from '@/lib/parsers/seo/seo';
import { useServerInsertedHTML } from 'next/navigation';

type Props = {
  scripts: ParsedSeoScripts['scripts'];
};

const SeomaticHeadScripts = ({ scripts }: Props) => {
  useServerInsertedHTML(() => {
    if (!scripts.length) return null;

    return (
      <>
        {scripts.map((script) => (
          <script
            key={script.id}
            id={script.id}
            type={script.type ?? 'text/javascript'}
            dangerouslySetInnerHTML={{ __html: script.html }}
          />
        ))}
      </>
    );
  });

  return null;
};

export default SeomaticHeadScripts;
